import { hbs } from 'ember-cli-htmlbars';
const __COLOCATED_TEMPLATE__ = hbs("<CommandPalette::Provider\n  @cache={{hash load=this.cacheLoad save=this.cacheSave}}\n  @key={{this.key}}\n  @modifierKey={{this.modifierKey}}\n  as |state actions|\n>\n  {{! @glint-expect-error: Shared::Modal }}\n  <Shared::Modal\n    @close={{actions.close}}\n    @focusTrap={{true}}\n    class=\"is--top h--globalSearch__modalWrapper\"\n    data-test-id=\"global-search\"\n    as |modal|\n  >\n    <modal.card @closeIcon={{false}} class=\"h--globalSearch__modal\">\n      <GlobalSearch::SearchInput @isRunning={{state.searching}} @onChange={{actions.search}} />\n      {{#if state.empty}}\n        <GlobalSearch::NoResults />\n      {{/if}}\n\n      {{#if @debug}}\n        <GlobalSearch::DebugQuery @query={{state.query}} />\n      {{/if}}\n\n      <GlobalSearch::SearchResultList @results={{state.searchResults}} as |result index|>\n\n        <GlobalSearch::SearchResult\n          @isSelected={{is-equal index state.selectedIndex}}\n          @result={{result}}\n          @runCommand={{fn actions.execute result}}\n        />\n      </GlobalSearch::SearchResultList>\n\n      <GlobalSearch::SearchFooter @results={{state.searchResults}} @selectedResultIndex={{state.selectedIndex}} />\n    </modal.card>\n  </Shared::Modal>\n</CommandPalette::Provider>", {"contents":"<CommandPalette::Provider\n  @cache={{hash load=this.cacheLoad save=this.cacheSave}}\n  @key={{this.key}}\n  @modifierKey={{this.modifierKey}}\n  as |state actions|\n>\n  {{! @glint-expect-error: Shared::Modal }}\n  <Shared::Modal\n    @close={{actions.close}}\n    @focusTrap={{true}}\n    class=\"is--top h--globalSearch__modalWrapper\"\n    data-test-id=\"global-search\"\n    as |modal|\n  >\n    <modal.card @closeIcon={{false}} class=\"h--globalSearch__modal\">\n      <GlobalSearch::SearchInput @isRunning={{state.searching}} @onChange={{actions.search}} />\n      {{#if state.empty}}\n        <GlobalSearch::NoResults />\n      {{/if}}\n\n      {{#if @debug}}\n        <GlobalSearch::DebugQuery @query={{state.query}} />\n      {{/if}}\n\n      <GlobalSearch::SearchResultList @results={{state.searchResults}} as |result index|>\n\n        <GlobalSearch::SearchResult\n          @isSelected={{is-equal index state.selectedIndex}}\n          @result={{result}}\n          @runCommand={{fn actions.execute result}}\n        />\n      </GlobalSearch::SearchResultList>\n\n      <GlobalSearch::SearchFooter @results={{state.searchResults}} @selectedResultIndex={{state.selectedIndex}} />\n    </modal.card>\n  </Shared::Modal>\n</CommandPalette::Provider>","moduleName":"later/components/global-search.hbs","parseOptions":{"srcName":"later/components/global-search.hbs"}});
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { isString } from 'lodash';

import type { ModifierKey, SearchCommandResult } from 'command-palette/types';
import type UserAgentService from 'ember-useragent/services/user-agent';
import type CacheService from 'later/services/cache';
import type ErrorsService from 'later/services/errors';
import type { UpperCaseCharacters } from 'type-fest/source/internal';

interface GlobalSearchComponentSignature {
  Element: HTMLDivElement;
  Args: {
    debug?: boolean;
  };
  Blocks: {
    default: [];
  };
}

export default class GlobalSearchComponent extends Component<GlobalSearchComponentSignature> {
  @service declare cache: CacheService;
  @service declare errors: ErrorsService;
  @service declare userAgent: UserAgentService;

  key: UpperCaseCharacters = 'K';

  get modifierKey(): ModifierKey {
    if (this.userAgent.os.isMacOS || this.userAgent.os.isIOS) {
      return 'metaKey';
    }
    return 'ctrlKey';
  }

  @action
  cacheSave(id: string, data: SearchCommandResult[]): boolean {
    try {
      this.cache.add(id, JSON.stringify(data), {
        expiry: this.cache.maxExpiryDate(),
        persist: true
      });
    } catch (error) {
      this.errors.log(error);
      return false;
    }

    return true;
  }

  @action
  cacheLoad(id: string): SearchCommandResult[] {
    try {
      const data: unknown = this.cache.retrieve(id);
      if (isString(data)) {
        return JSON.parse(data) as SearchCommandResult[];
      }

      return [];
    } catch (error) {
      this.errors.log(error);
      return [];
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    GlobalSearch: typeof GlobalSearchComponent;
    'global-search': typeof GlobalSearchComponent;
  }
}
